export const BLUESYSTEMS_URL = 'https://www.bluesystems.io/'
